import _toConsumableArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { assign, map } from 'lodash';
import faker from 'faker/locale/zh_CN';
import { service, request, serviceForMock, requestForMock, mock } from './_service';
import * as tools from './tools';
import { api2 } from "@api/env";
var files = require.context('./modules', true, /\.api\.js$/);
var generators = files.keys().map(function (key) {
  return files(key).default;
});
var uploadParams = {
  transformRequest: [function (d) {
    return d;
  }],
  timeout: 6000 * 5,
  method: 'post'
};
var uri2 = api2;
export function imageUrl(id) {
  return uri2 + "/File/Get?Id=".concat(id);
}
export { uploadParams, request };
export default assign.apply(void 0, [{}].concat(_toConsumableArray(map(generators, function (generator) {
  return generator({
    uploadParams: uploadParams,
    service: service,
    request: request,
    serviceForMock: serviceForMock,
    requestForMock: requestForMock,
    mock: mock,
    faker: faker,
    tools: tools
  });
}))));